import { render, staticRenderFns } from "./index-report.vue?vue&type=template&id=bc5d4682"
import script from "./index-report.vue?vue&type=script&lang=js"
export * from "./index-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc5d4682')) {
      api.createRecord('bc5d4682', component.options)
    } else {
      api.reload('bc5d4682', component.options)
    }
    module.hot.accept("./index-report.vue?vue&type=template&id=bc5d4682", function () {
      api.rerender('bc5d4682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/sales-comissions/index-report.vue"
export default component.exports